import { HTMLAttributes } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';

type DialogContentProps = HTMLAttributes<HTMLDivElement>;

const DialogContent = (props: DialogContentProps) => {
  const { className, children } = props;

  return (
    <Box
      className={clsx('flex h-0 flex-1 flex-col overflow-auto p-5', className)}
    >
      {children}
    </Box>
  );
};

export default DialogContent;
